module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAALVBMVEUAAACAgICAgP+/v8+0w8PDw8O2tsK2wsK4u8K7u8W6usS4u8W6u8W6vcW6vMUNSCSiAAAADnRSTlMAAgIQEREVFUtLTk/T0wVt0jwAAABtSURBVBjTY2AgC0g5gEiWhWBO3zEQmfMSzIl9k8DAwHbuKJjDfg8olQMSAYHaNwls545BTQBKwSWAUm/vHYMbzn7vbQJ2DrIyoAG1cAOALHaYFJgBk7J9WwASOQxx6HWwWohDtQNAJOsm8gIAAFhLLS/g4FtAAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_colse.png
// module id = gGwM
// module chunks = 47